import type { PropsWithChildren } from 'react';
import { GovDropdown, GovIcon } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import { Button } from '@gov-nx/ui/web';
import type { IUseBoolean } from '@gov-nx/utils/common';

const DropdownLabel = ({
	label,
	labelLeft,
}: {
	labelLeft: string;
	label: string;
}) => (
	<>
		<span className="gov-text-weight--normal">{labelLeft}: </span>
		{label}
	</>
);
const DropdownButton = ({
	children,
	onClick,
}: {
	onClick: () => void;
} & PropsWithChildren) => (
	<Button
		color="neutral"
		size="m"
		type="base"
		isExpanded
		onClick={onClick}>
		{children}
	</Button>
);

export const SortDropdown = ({
	code,
	isSortedAlphabetically,
}: {
	code: string;
	isSortedAlphabetically: IUseBoolean;
}) => {
	const { t } = useLocale(code);

	const buttonLabel = isSortedAlphabetically.isTrue
		? t('akce.nejcasteji-navstevovane')
		: t('akce.abecedne');

	const dropdownOnClick = () => {
		isSortedAlphabetically.toggle();
	};

	const dropdownLabel = isSortedAlphabetically.isTrue
		? t('akce.abecedne')
		: t('akce.nejcasteji-navstevovane');

	return (
		<>
			<GovDropdown
				position="right"
				color="primary"
				size="m"
				type="base"
				className="hidden! md:block!"
				iconStart={
					<GovIcon
						name="sort-down"
						type="templates"
					/>
				}
				label={
					<DropdownLabel
						labelLeft={t('akce.razeni')}
						label={dropdownLabel}
					/>
				}
				iconEnd={
					<GovIcon
						name="chevron-down"
						type="components"
					/>
				}>
				<DropdownButton onClick={dropdownOnClick}>{buttonLabel}</DropdownButton>
			</GovDropdown>
			<GovDropdown
				position="right"
				color="primary"
				size="m"
				type="outlined"
				expanded
				className="button-fixed-width md:hidden!"
				iconStart={
					<GovIcon
						name="sort-down"
						type="templates"
					/>
				}
				label={
					<DropdownLabel
						labelLeft={t('akce.razeni')}
						label={dropdownLabel}
					/>
				}>
				<DropdownButton onClick={dropdownOnClick}>{buttonLabel}</DropdownButton>
			</GovDropdown>
		</>
	);
};
